
import React from 'react';
import Layout from '@/components/Layout';
import { Link } from 'react-router-dom';
import { ChevronLeft } from 'lucide-react';

interface ResourcePageLayoutProps {
  title: string;
  description?: string;
  children: React.ReactNode;
}

const ResourcePageLayout: React.FC<ResourcePageLayoutProps> = ({
  title,
  description,
  children
}) => {
  return (
    <Layout>
      <div className="container py-8 max-w-4xl mx-auto px-4">
        <div className="mb-6">
          <Link 
            to="/" 
            className="inline-flex items-center text-hormony-charcoal/70 hover:text-hormony-coral transition-colors mb-4"
          >
            <ChevronLeft size={18} />
            <span>Back to Home</span>
          </Link>
          
          <h1 className="text-3xl font-bold text-hormony-charcoal mb-2">{title}</h1>
          {description && (
            <p className="text-hormony-charcoal/80 mb-6">{description}</p>
          )}
        </div>
        
        {children}
      </div>
    </Layout>
  );
};

export default ResourcePageLayout;
